export default function genAbilityHashId(agent, abilitySlot) {
  return `${agent.id}#${abilitySlot}`.toLowerCase()
}
